"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _styling = require("../../../../toolkit/styling");

var _localization = require("../../../../toolkit/localization");

var _providers = require("../../../../toolkit/providers");

//
//  src/data/table/mobile/TableMobileRowExpansion.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 4/1/2020.
//  Copyright © 2020-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */
var _default = (0, _mobxReact.observer)(function (_ref) {
  var row = _ref.row,
      section = _ref.section,
      rowIndex = _ref.rowIndex,
      className = _ref.className,
      style = _ref.style;

  var _useLocalization = (0, _localization.useLocalization)(),
      i18n = _useLocalization.i18n;

  var renderExpanded = section.renderExpanded;

  if (!renderExpanded) {
    return null;
  }

  var styles = useStylesheet();
  var isRowExpanded = section.isRowExpanded(rowIndex);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(className, style, styles.root)
  }, isRowExpanded && renderExpanded(row.row), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.buttonRow),
    onClick: function onClick() {
      return section.onRowExpandToggled(row);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.buttonText)
  }, isRowExpanded ? i18n("Less...") : i18n("More..."))));
});

exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  var _useTheming = (0, _providers.useTheming)(),
      fonts = _useTheming.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch"
      },
      buttonRow: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px 0px",
        cursor: "pointer",
        userSelect: "none"
      },
      buttonText: {
        marginLeft: 7,
        fontFamily: fonts.semibold,
        fontSize: 18
      }
    });
  }, [fonts.semibold]);
};